import React from 'react';
import { ChartStateProvider } from '@client/state/chart-state.hook';
import { DraftStateProvider } from '@client/state/draft-form-state.hook';
import { useTradingForm } from '@client/widgets/trading-form/trading-form.hook';
import { useHandleLastUpdatedChart } from '@client/widgets/chart/services/handle-last-updated-chart.hook';
import { useCreateTemplateForm } from '@client/features/trading-templates/create-template/create-template-form.hook';
import { useManageTradingTemplates } from '@client/features/trading-templates/load-template/manage-trading-templates.hook';
import { useCreateLayoutForm } from '@client/features/trading-layouts/create-layout-form.hook';
import { useManageTradingLayouts } from '@client/features/trading-layouts/manage-trading-layouts.hook';
import { useCreateWorkspaceLayoutForm } from '@client/features/workspace-layouts/create-workspace-layout-form.hook';
import { useManageWorkspaceLayouts } from '@client/features/workspace-layouts/manage-workspace-layouts.hook';
import { TradingWorkspaceDestroyProvider } from './trading-workspace-scope.context';

const TradingWorkspaceEffects = () => {
  useTradingForm();
  useHandleLastUpdatedChart();
  useCreateTemplateForm();
  useManageTradingTemplates();
  useCreateLayoutForm();
  useManageTradingLayouts();
  useCreateWorkspaceLayoutForm();
  useManageWorkspaceLayouts();

  return null;
};

export const TradingWorkspaceProvider = ({
  children
}: {
  children: React.ReactNode;
}) => {
  return (
    <TradingWorkspaceDestroyProvider>
      <ChartStateProvider>
        <DraftStateProvider>
          <TradingWorkspaceEffects />
          {children}
        </DraftStateProvider>
      </ChartStateProvider>
    </TradingWorkspaceDestroyProvider>
  );
};
